export const colorMap: { [key: string]: string } = {
    ROJ: "#ff0000", 
    VER: "#29ff7b", 
    AZU: "#006eff",
    AMA: "#ffe200",
  };
  